// extracted by mini-css-extract-plugin
export default {"root":"Grid_root__k6Lha","grid":"Grid_grid__Q6nQD"};